"use strict";

function _typeof(obj) { "@babel/helpers - typeof"; if (typeof Symbol === "function" && typeof Symbol.iterator === "symbol") { _typeof = function _typeof(obj) { return typeof obj; }; } else { _typeof = function _typeof(obj) { return obj && typeof Symbol === "function" && obj.constructor === Symbol && obj !== Symbol.prototype ? "symbol" : typeof obj; }; } return _typeof(obj); }

Object.defineProperty(exports, "__esModule", {
  value: true
});
exports.default = void 0;

var React = _interopRequireWildcard(require("react"));

function _getRequireWildcardCache() { if (typeof WeakMap !== "function") return null; var cache = new WeakMap(); _getRequireWildcardCache = function _getRequireWildcardCache() { return cache; }; return cache; }

function _interopRequireWildcard(obj) { if (obj && obj.__esModule) { return obj; } if (obj === null || _typeof(obj) !== "object" && typeof obj !== "function") { return { default: obj }; } var cache = _getRequireWildcardCache(); if (cache && cache.has(obj)) { return cache.get(obj); } var newObj = {}; var hasPropertyDescriptor = Object.defineProperty && Object.getOwnPropertyDescriptor; for (var key in obj) { if (Object.prototype.hasOwnProperty.call(obj, key)) { var desc = hasPropertyDescriptor ? Object.getOwnPropertyDescriptor(obj, key) : null; if (desc && (desc.get || desc.set)) { Object.defineProperty(newObj, key, desc); } else { newObj[key] = obj[key]; } } } newObj.default = obj; if (cache) { cache.set(obj, newObj); } return newObj; }

function _extends() { _extends = Object.assign || function (target) { for (var i = 1; i < arguments.length; i++) { var source = arguments[i]; for (var key in source) { if (Object.prototype.hasOwnProperty.call(source, key)) { target[key] = source[key]; } } } return target; }; return _extends.apply(this, arguments); }

function ic_padlock__open(props) {
  return /*#__PURE__*/React.createElement("svg", _extends({
    id: "cd6cf20d-0337-4236-b2c5-e50f64ce07ae",
    "data-name": "security-hi",
    xmlns: "http://www.w3.org/2000/svg",
    xmlnsXlink: "http://www.w3.org/1999/xlink",
    width: "1em",
    height: "1em",
    viewBox: "0 0 192.02 192"
  }, props), /*#__PURE__*/React.createElement("defs", null, /*#__PURE__*/React.createElement("linearGradient", {
    id: "917dfc98-0161-482d-9b0b-591d23da1c15",
    x1: 90.94,
    y1: 120.85,
    x2: 148.35,
    y2: 178.27,
    gradientUnits: "userSpaceOnUse"
  }, /*#__PURE__*/React.createElement("stop", {
    offset: 0
  }), /*#__PURE__*/React.createElement("stop", {
    offset: 1,
    stopOpacity: 0
  }))), /*#__PURE__*/React.createElement("title", null, "padlock-open-hi"), /*#__PURE__*/React.createElement("g", {
    id: "f60d6874-3067-41b8-a086-ade5d9ed1128",
    "data-name": "Apps_ic_hi"
  }, /*#__PURE__*/React.createElement("g", {
    id: "4544c25b-ab8a-4a28-990f-b7d53a2362bd",
    "data-name": "Bill_ic_hi"
  }, /*#__PURE__*/React.createElement("g", {
    id: "50f15daf-dd37-4397-85ac-beb9cb29403f",
    "data-name": "Report_ic_hi"
  }, /*#__PURE__*/React.createElement("g", {
    id: "98bb0a1c-8727-4060-bd6e-d8c6f722c83d",
    "data-name": "vodafone_store_ic_hi"
  }, /*#__PURE__*/React.createElement("g", {
    id: "11b76320-1e6b-4639-a03e-c1dfc7f68005",
    "data-name": "Broadband_ic_hi"
  }, /*#__PURE__*/React.createElement("g", {
    id: "d2a40fa6-0168-41b5-98a6-98e6d77a1cda",
    "data-name": "Business_ic_hi"
  }, /*#__PURE__*/React.createElement("g", {
    id: "04dd30a1-b18d-4834-b2b3-a5807e9b9107",
    "data-name": "Calendar_ic_hi"
  }, /*#__PURE__*/React.createElement("g", {
    id: "fcd465fc-8435-4ecf-afea-cc58da347bba",
    "data-name": "Camera_ic_hi"
  }, /*#__PURE__*/React.createElement("g", {
    id: "9cd74584-b27f-477e-a999-2bc6a1579ccc",
    "data-name": "Data_ic_hi"
  }, /*#__PURE__*/React.createElement("g", {
    id: "04bbaf17-df3a-42fb-8dfe-1b0cf1391c0a",
    "data-name": "Desktop_ic_hi"
  }, /*#__PURE__*/React.createElement("g", {
    id: "68c6be26-a8d4-482b-9ef9-8666af15f24d",
    "data-name": "Document_ic_hi"
  }, /*#__PURE__*/React.createElement("g", {
    id: "f222e10e-c554-4ab0-8199-b2a1da8f9bce",
    "data-name": "Edit_ic_hi"
  }, /*#__PURE__*/React.createElement("g", {
    id: "c3c97173-9b56-4b90-8815-9d106face76b",
    "data-name": "Enterprise_ic_hi"
  }, /*#__PURE__*/React.createElement("g", {
    id: "28ae78ea-eeb2-4efb-afa7-4146c4c97bc3",
    "data-name": "Call_ic_hi"
  }, /*#__PURE__*/React.createElement("g", {
    id: "5247eb3e-bc74-43ee-8467-308e216b4357",
    "data-name": "Location_ic_hi"
  }, /*#__PURE__*/React.createElement("g", {
    id: "26821b91-34e5-4423-a9f6-7a6bf894307a",
    "data-name": "Mail_new_ic_hi"
  }, /*#__PURE__*/React.createElement("g", {
    id: "dbaf2632-8f91-4a9b-81c8-255094820aef",
    "data-name": "Mail_unread_ic_hi"
  }, /*#__PURE__*/React.createElement("g", {
    id: "5c0bcf82-f7e2-4fe6-ab21-37d6963f7768",
    "data-name": "Mobile_ic_hi"
  }, /*#__PURE__*/React.createElement("g", {
    id: "fa643d6d-3e6f-499c-8e85-9991a985ca2f",
    "data-name": "Network_ic_hi"
  }, /*#__PURE__*/React.createElement("g", {
    id: "dc097df7-1473-4152-9b0e-993f12535e98",
    "data-name": "Reports_ic_hi"
  }, /*#__PURE__*/React.createElement("g", {
    id: "f1591d66-428d-439d-8775-d4dd0dc5527a",
    "data-name": "Roaming_ic_hi"
  }, /*#__PURE__*/React.createElement("g", {
    id: "d007f3e6-e753-4116-8478-17a9a9b830c0",
    "data-name": "Security_ic_hi"
  }, /*#__PURE__*/React.createElement("path", {
    d: "M72,76H64V48.55C64,35.12,53,23.78,39.59,24A24,24,0,0,0,16,48V64a4,4,0,0,1-4,4h0a4,4,0,0,1-4-4V48.64C8,30.73,22.65,15.7,40.55,16A32,32,0,0,1,72,48Z",
    transform: "translate(0.01 0)",
    fill: "#e60000"
  }), /*#__PURE__*/React.createElement("rect", {
    id: "b051bf09-cd8a-482f-9c5d-f5038573920f",
    "data-name": "Bounding Box",
    width: 192,
    height: 192,
    fill: "none"
  }), /*#__PURE__*/React.createElement("g", {
    opacity: 0.12
  }, /*#__PURE__*/React.createElement("path", {
    d: "M64,46a24,24,0,0,0-48,0v2a24,24,0,0,1,48,0Z",
    transform: "translate(0.01 0)"
  })), /*#__PURE__*/React.createElement("rect", {
    x: 31.83,
    y: 72,
    width: 128.17,
    height: 104,
    rx: 16,
    ry: 16,
    fill: "#ebebeb"
  }), /*#__PURE__*/React.createElement("rect", {
    x: 0.02,
    width: 192,
    height: 192,
    fill: "none"
  }), /*#__PURE__*/React.createElement("path", {
    d: "M144,174H47.82a16,16,0,0,1-16-16v2a16,16,0,0,0,16,16H144a16,16,0,0,0,16-16v-2A16,16,0,0,1,144,174Z",
    transform: "translate(0.01 0)",
    opacity: 0.06
  }), /*#__PURE__*/React.createElement("path", {
    d: "M96,107.36a9.82,9.82,0,0,1,9.75,8.7c0-.3.06-.59.06-.89a9.81,9.81,0,1,0-19.62,0,8.89,8.89,0,0,0,.07.89A9.8,9.8,0,0,1,96,107.36Z",
    transform: "translate(0.01 0)"
  }), /*#__PURE__*/React.createElement("path", {
    d: "M96,105.36a9.81,9.81,0,0,1,4,18.76V148a4,4,0,0,1-8,0V124.12a9.81,9.81,0,0,1,4-18.76m0-4a13.81,13.81,0,0,0-8,25.06V148a8,8,0,0,0,16,0V126.42a13.81,13.81,0,0,0-8-25.06Z",
    transform: "translate(0.01 0)",
    fill: "#f4f4f4"
  }), /*#__PURE__*/React.createElement("path", {
    d: "M105.82,115.17a9.81,9.81,0,1,0-13.81,9V148a4,4,0,0,0,8,0V124.12A9.81,9.81,0,0,0,105.82,115.17Z",
    transform: "translate(0.01 0)",
    fill: "#4a4d4e"
  }), /*#__PURE__*/React.createElement("g", {
    opacity: 0.12
  }, /*#__PURE__*/React.createElement("path", {
    d: "M96,105.36a9.81,9.81,0,0,1,4,18.76V148a4,4,0,0,1-8,0V124.12a9.81,9.81,0,0,1,4-18.76m0-4a13.81,13.81,0,0,0-8,25.06V148a8,8,0,0,0,16,0V126.42a13.81,13.81,0,0,0-8-25.06Z",
    transform: "translate(0.01 0)"
  })), /*#__PURE__*/React.createElement("g", {
    opacity: 0.2
  }, /*#__PURE__*/React.createElement("path", {
    d: "M106.06,105.73a13.77,13.77,0,0,1-2,20.69V148a8,8,0,0,1-8,8,7.8,7.8,0,0,1-3.7-.92L114,176h30a16,16,0,0,0,16-16v-3Z",
    transform: "translate(0.01 0)",
    fill: "url(#917dfc98-0161-482d-9b0b-591d23da1c15)"
  })))))))))))))))))))))))));
}

var _default = ic_padlock__open;
exports.default = _default;